/** * Scroll to the form validation notice if it is not visible in a viewport ** */
/** * If input error notice is present scroll into a view ** */
/** * If input error is NOT present scroll to the form notice error ** */

import {
  isElementInViewport,
  getRelativeScrollTop,
  nextFrame,
} from '@crossiety/lit-components/lib/helpers.js';

export default class InvalidFormHandler {
  static config = {
    formErrorNoticeClass: 'alert-danger',
    inputErrorNoticeClass: 'invalid',
  };

  constructor(target) {
    this.target = target;
    this.targetOffset = 15;
  }

  /** @internal */
  get config() {
    return this.constructor.config;
  }

  get scrollTopPosition() {
    return getRelativeScrollTop(this.primaryError, this.target);
  }

  async start() {
    await nextFrame();

    const { formErrorNoticeClass, inputErrorNoticeClass } = this.config;
    const formError = this.target.querySelector(`.${formErrorNoticeClass}`);
    const inputError = this.target.querySelector(`.${inputErrorNoticeClass}`);

    this.primaryError = inputError || formError;

    if (!this.primaryError) return;
    if (isElementInViewport(this.primaryError, this.target)) return;

    this.target.scrollTo({
      top: this.scrollTopPosition - this.targetOffset,
      behavior: 'smooth',
    });
  }
}
